import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout'; // Можливо, ви захочете використати Layout
import SEO from '../components/SEO';
import '../css/NotFoundPage.css';

const NotFoundPage = () => {
    return (
        <Layout>
            <SEO
                title="Сторінку не знайдено - 404"
                description="Вибачте, але сторінка, яку ви шукали, не існує. Поверніться на головну сторінку UnionAuto."
                canonical="/404"
                noindex={true}
            />
            <div className="not-found-container">
                <h1>404</h1>
                <h2>Сторінку не знайдено</h2>
                <p>Вибачте, але сторінка, яку ви шукали, не існує.</p>
                <Link to="/" className="home-link">
                    Повернутися на головну
                </Link>
            </div>
        </Layout>
    );
};

export default NotFoundPage; 